// extracted by mini-css-extract-plugin
export default {"like":"qT0sU","liked":"filJZ"};